import "./wdyr";
import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";

import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import * as serviceWorker from "./serviceWorker";

import { Provider } from "react-redux";
import store, { history, persistor } from "./store";
import { ConnectedRouter } from "connected-react-router";
import { PersistGate } from "redux-persist/integration/react";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";

import LuxonUtils from "@date-io/luxon";

import * as Sentry from "@sentry/react";
import { Integrations } from "@sentry/tracing";

import "./i18n";
import "./api";

const environment = process.env.REACT_APP_ENV || "local";
if (environment !== "local" && process.env.REACT_APP_SENTRY_URL) {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_URL,
    integrations: [new Integrations.BrowserTracing()],
    environment,
    tracesSampleRate: 1.0,
  });
}

// expose store to dev, ex: Cypress
if (environment !== "prod") {
  window.store = store;
}

ReactDOM.render(
  <Provider store={store}>
    <PersistGate persistor={persistor}>
      <ConnectedRouter history={history}>
        <MuiPickersUtilsProvider utils={LuxonUtils}>
          <App />
        </MuiPickersUtilsProvider>
      </ConnectedRouter>
    </PersistGate>
  </Provider>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
